import React, { Component } from "react";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: props.initialValues?.firstname || "",
      lastname: props.initialValues?.lastname || "",
      email: props.initialValues?.email || "",
      phone: props.initialValues?.phone || "",
      dob: props.initialValues?.dob || "",
      touched: {},
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleBlur = (e) => {
    const { name } = e.target;
    this.setState((prev) => ({
      touched: { ...prev.touched, [name]: true },
    }));
  };

  // simple validators
  isEmailValid = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  isPhoneValid = (phone) =>
    /^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(phone.trim());

  isComplete = () => {
    const { firstname, lastname, email, phone, dob } = this.state;
    return (
      firstname.trim() &&
      lastname.trim() &&
      this.isEmailValid(email) &&
      this.isPhoneValid(phone) &&
      dob.trim()
    );
  };

  handleSubmit = () => {
    if (this.isComplete()) {
      const { firstname, lastname, email, phone, dob } = this.state;
      this.props.onStartQuiz({ firstname, lastname, email, phone, dob });
    }
  };

  render() {
    const { firstname, lastname, email, phone, dob, touched } = this.state;
    const emailInvalid = touched.email && email && !this.isEmailValid(email);
    const phoneInvalid = touched.phone && phone && !this.isPhoneValid(phone);
    const canStart = this.isComplete();

    return (
      <section className="home section" style={{ backgroundImage: "url(https://s3.us-east-1.amazonaws.com/cdn.fanduel.com/images/marketing-frontend/2026/sportsbook/nhl/sweepstakes-quiz/images/home-bg.jpg)" }}>
        <img className="home__baseball " src="https://s3.us-east-1.amazonaws.com/cdn.fanduel.com/images/marketing-frontend/2026/sportsbook/nhl/sweepstakes-quiz/images/gloves.png" alt="" />
        <div className="grid-container">
          <div className="grid-x grid-padding-x">
            <div className="small-12 small-offset-0 medium-10 medium-offset-1 cell">
              <img className="home__logos" src="https://s3.us-east-1.amazonaws.com/cdn.fanduel.com/images/marketing-frontend/2026/sportsbook/nhl/sweepstakes-quiz/images/playwithaplan-logo.png" alt="Logo" />
              <img className="home__h1" src="https://s3.us-east-1.amazonaws.com/cdn.fanduel.com/images/marketing-frontend/2026/sportsbook/nhl/sweepstakes-quiz/images/your-chance.png" />

     
              <h2 className="home__h2">
SMART PLAY STARTS HERE - TAKE THE PLAY SMARM QUICK TO ENTER!
              </h2>
        
              <h3 className="home__h3">Check In To The Action</h3>
              <p className="home__p">
        Enter your details to take the Play Smart Quiz and get a shot at a NHL Shop gift code.
 </p>

              <div className="home__form">
                <label>
                  FIRST NAME:
                  <input
                    type="text"
                    className="home__form-input"
                    name="firstname"
                    placeholder="First Name"
                    value={firstname}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    required
                  />
                </label>
                <label>
                  LAST NAME:
                  <input
                    type="text"
                    className="home__form-input"
                    name="lastname"
                    placeholder="Last Name"
                    value={lastname}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    required
                  />
                </label>
                <label>
                  EMAIL ADDRESS:
                  <input
                    type="email"
                    className={`home__form-input${emailInvalid ? " is-invalid" : ""}`}
                    name="email"
                    placeholder="Email (associated with your FanDuel Account)"
                    value={email}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    required
                  />
                </label>
                {emailInvalid && (
                  <small className="form-error">Please enter a valid email address.</small>
                )}
                <label>
                  PHONE NUMBER:
                  <input
                    type="tel"
                    className={`home__form-input${phoneInvalid ? " is-invalid" : ""}`}
                    name="phone"
                    placeholder="(XXX) XXX-XXXX"
                    value={phone}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    required
                  />
                </label>
                {phoneInvalid && (
                  <small className="form-error">Please enter a valid US phone number.</small>
                )}
                <label>
                  DATE OF BIRTH:
                  <input
                    type="date"
                    className="home__form-input"
                    name="dob"
                    placeholder="XX/XX/XXXX"
                    value={dob}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    required
                  />
                </label>
              </div>

              {canStart ? (
                <button className="home__cta" onClick={this.handleSubmit}>
                  START QUIZ
                </button>
              ) : (
                <button className="home__cta disabled" disabled aria-disabled="true">
                  START QUIZ
                </button>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Home;
